import { render, staticRenderFns } from "./upload-group-element-obj.vue?vue&type=template&id=818c8654&scoped=true"
import script from "./upload-group-element-obj.vue?vue&type=script&lang=js"
export * from "./upload-group-element-obj.vue?vue&type=script&lang=js"
import style0 from "./upload-group-element-obj.vue?vue&type=style&index=0&id=818c8654&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"
import style1 from "./upload-group-element-obj.vue?vue&type=style&index=1&id=818c8654&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818c8654",
  null
  
)

export default component.exports